import { Button, Container, Stack, Text } from '@chakra-ui/react';

import Link from 'next/link';
import type { NextPage } from 'next';
import React from 'react';

const drinks: NextPage = () => {
  return (
    <Container my={8}>
      <Stack>
        <Text>drinks are coming sooooon 🍻</Text>
        <Link href="/" passHref>
          <Button>Go Home for now 😉</Button>
        </Link>
      </Stack>
    </Container>
  );
};

export default drinks;
